import { Typography, Box } from "@mui/material";
import React from "react";

const Header = ({ title, subtitle }) => {
    return (
        <Box>
            <Typography variant="h2" sx={{ fontWeight: 700, color: "#1a2138", mb: "2px" }}>
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="body2" sx={{ color: "#5a6a85" }}>
                    {subtitle}
                </Typography>
            )}
        </Box>
    );
};

export default Header;
